

































































































































import _ from 'lodash'
import moment from 'moment'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import CadastroLayoutEmailStore from '@/components/RemuneracaoMedica/financeiro/Store/CadastroLayoutEmailStore'
import { RequestMessage } from '@/types/_'
import EventBus from '@/plugins/EventBus'
import { onlyNumber } from '@/utils/common'

@Component
export default class ViewFinanceiroNotificarEmail extends Vue {
  $refs!: {
    diaForm: any,
  }

  inputFiles: any[] = []
  loadNotificar: boolean = false
  loadTemplate: boolean = false
  dia: any = ''
  envioEmail: any = ''
  grupoRepasse: any = ''
  showModalTemplateConfig: boolean = false
  currentTab: any = 'tab-0'

  diaRules: any = {
    valid: true,
    dia: [
      v => !!v || 'O campo dia é obrigatório.',
    ],
  }

  get getDia() {
    return this.dia
  }

  set getDia(value: any) {
    this.dia = value
  }

  get getEnvioEmail() {
    return this.envioEmail
  }

  set getEnvioEmail(value: any) {
    this.envioEmail = value
  }

  get getGrupoRepasse() {
    return this.grupoRepasse
  }

  set getGrupoRepasse(value: any) {
    this.grupoRepasse = value
  }

  get loadingNotificar() {
    return this.loadNotificar
  }

  set loadingNotificar(value: boolean) {
    this.loadNotificar = value
  }

  get loadingTemplate() {
    return this.loadTemplate
  }

  set loadingTemplate(value: boolean) {
    this.loadTemplate = value
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getStore() {
    return getModule(CadastroLayoutEmailStore, this.$store)
  }

  get getGrupoRepasseItensAll() {
    return this.getFinanceiroStore.grupoRepasseItensAll
  }

  set getGrupoRepasseItensAll(value: any[]) {
    this.getFinanceiroStore.grupoRepasseItensAll = value
  }

  get templateNotificarConfig() {
    return this.getFinanceiroStore.templateNotificarConfig
  }

  get emailCorpoNotificar() {
    return this.getStore.emailCorpo
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async sendEmailCobrancaNotaFiscal() {
    this.loadingNotificar = true
    const params: any = {
      diasDesdeUltimaNotificacao: this.getDia ? this.getDia : 0,
      grupoRepasseId: this.grupoRepasse ? this.grupoRepasse : null,
      // eslint-disable-next-line
      envioEmailTipo: parseInt(this.envioEmail),
    }

    const response = await this.getFinanceiroStore.sendEmailCobrancaNotaFiscal(params)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Email enviado com sucesso.', icon: 'done', color: '#2E7D32' })
      this.getDia = ''
      this.envioEmail = '0'
      this.grupoRepasse = ''
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema ao enviar o arquivo.', icon: 'warning', color: '#C62828' })
    }

    this.loadingNotificar = false
  }

  async getTemplateNotificacaoConfig() {
    this.loadingTemplate = true
    const param: any = {
      // eslint-disable-next-line
      envioEmailTipo: parseInt(this.envioEmail),
    }

    const response = await this.getFinanceiroStore.getTemplateNotificacaoConfig(param)
    if (response.success) {
      this.showModalTemplateConfig = true
      await this.getLayoutEmailById()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema ao pré-visualizar o template.', icon: 'warning', color: '#C62828' })
    }
    this.loadingTemplate = false
  }
  
  async getLayoutEmailById() {
    this.loadTemplate = true

    const hospital = this.templateNotificarConfig[parseInt(this.currentTab.replace('tab-', ''))]
    const params: any = {
        hospitalId: hospital.hospitalId,
        tipoNome: this.envioEmail,
      }

    await this.getStore.getLayoutEmailById(params)
    this.loadTemplate = false
  }

  closeModalTemplateConfig() {
    this.showModalTemplateConfig = false
    this.currentTab = 'tab-0'
  }

  @Watch('currentTab')
  async onChangeCurrentTab() {
    await this.getLayoutEmailById()
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getFinanceiroStore.getGrupoRepasseAll()
    this.envioEmail = '0'
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }
}
